export default "__VITE_ASSET__DLEy40F5__"